import { SessionService } from "../../base/services/session.service";

// The link in the backend's billing emails: /subscription-plans?organizationId=<id>
// (Billing:BillingPageUrl). Signed in, the routes select that organization and
// open the page (Routes.js). Signed out, the sign-in pages answer every address
// with the login form, so the link is kept for the tab and the login goes on
// to it instead of the start page; the routes then select the organization as
// they would for anybody signed in. Someone who isn't a member of it lands on
// the organization list.

const KEY = "billingEmailLink";
const PATH = "/subscription-plans";

/** Whether an address is a billing email's link: the Subscription page, naming an organization. */
export const isBillingEmailLink = (pathname, search) =>
   pathname === PATH && Boolean(new URLSearchParams(search).get("organizationId"));

/** Keeps the link for the login that follows, in this tab only. */
export const rememberBillingEmailLink = (pathname, search) => {
   if (isBillingEmailLink(pathname, search)) SessionService.setItem(KEY, `${pathname}${search}`);
};

/**
 * The link kept for this login, once: it is let go of as it is read. Only the
 * Subscription page with its organization comes back, never another address.
 */
export const takeBillingEmailLink = () => {
   const link = SessionService.getItem(KEY);
   SessionService.removeItem(KEY);
   if (typeof link !== "string") return null;

   const url = new URL(link, window.location.origin);
   return isBillingEmailLink(url.pathname, url.search) ? `${url.pathname}${url.search}` : null;
};
